import { useState, useEffect } from "react"
import Login from "../data/Login"
import HeaderPromotions from "../data/HeaderPromotions"
import SearchGamesLibrary from "./global_functions/SearchGamesLibrary"
import { useLocation } from "react-router-dom"

export default function TopHeaderNav() {
  const [showSearch, setShowSearch] = useState(false)
  const location = useLocation()

  const [windowWidth, setWindowWidth] = useState(window.innerWidth)
  useEffect(() => {
    const handleResize = () => setWindowWidth(window.innerWidth)
    window.addEventListener("resize", handleResize)
    return () => window.removeEventListener("resize", handleResize)
  }, [])

  const isProfilePage = location.pathname.includes("/profile")
  const hideOnProfileMobile = isProfilePage && windowWidth <= 840
  if (hideOnProfileMobile) {
    return null
  }

  return (
    <>
      <div className="header-nav-container">
        <section className="header-nav-content">
          <div className="header-logo">
            <a href="/" className="header-nav-logo">
              <img src="/images/icon/FGH-CHRISTMAS.webp" alt="FGH Logo" />
            </a>
            <HeaderPromotions />
          </div>
          <div className="header-global-details">
            <div className="global-search-game-btn">
              <button onClick={() => setShowSearch(true)}>
                Search Game
                <img src="/images/icon/search-icon.webp" />
              </button>
            </div>
            <Login />
          </div>
        </section>
      </div>
      {showSearch && (
        <SearchGamesLibrary onClose={() => setShowSearch(false)} />
      )}
    </>
  )
}
